import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useConfig, useNotification } from '@revenuewell/front-end-bundle';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { CloseDialogButton, DialogContentWrapper, DialogSubTitle } from '../../dialog/dialog.styles';
import { TemplateSkeleton } from '../template.skeleton';
import { CommunicationInfo, TemplateImageWrapper } from './template-viewer.styles';

export interface TemplateViewerDialogProps {
  open: boolean;
  communicationId?: string;
  title?: string;
  date?: string;
  to?: string;
  subject?: string;
  onClose?: () => void;
}
export const TemplateViewerDialog: FC<TemplateViewerDialogProps> = (props) => {
  const { open, title, date, to, subject, onClose, communicationId } = props;
  const { config } = useConfig();
  const { showError } = useNotification();
  const [src, setSrc] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!communicationId) return;

    (async () => {
      setLoading(true);
      const url = `${config.practice.url}/Communication/GetCommunicationTemplate?idCommunication=${communicationId}`;

      setSrc(url);
    })();
  }, [communicationId]);

  const handleTemplateLoad = () => {
    setLoading(false);
  };

  const handleTemplateError = () => {
    showError('Unable to load Template.');
    setLoading(false);
  };

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <>
      <Dialog open={open} maxWidth={false} sx={{ zIndex: 9999 }}>
        <DialogContentWrapper>
          <DialogTitle sx={{ cursor: 'default', color: 'black' }}>
            {title ?? 'Email'}
            <CloseDialogButton onClick={handleClose} />
          </DialogTitle>
          <DialogContent>
            <DialogSubTitle sx={{ fontSize: '16px', display: 'flex', flexDirection: 'column' }}>
              <CommunicationInfo>
                {date && (
                  <li>
                    <Box>Date:</Box> {moment.parseZone(date).format('MM/DD/YYYY')}
                  </li>
                )}
                {to && (
                  <li>
                    <Box>To:</Box> {to}
                  </li>
                )}
                {subject && (
                  <li>
                    <Box>Subject:</Box> {subject}
                  </li>
                )}
              </CommunicationInfo>
            </DialogSubTitle>
            <TemplateImageWrapper>
              {(loading || !src) && <TemplateSkeleton />}
              {src && (
                <iframe
                  src={src}
                  onLoad={handleTemplateLoad}
                  onError={handleTemplateError}
                  style={{
                    visibility: loading ? 'hidden' : 'visible',
                    width: '700px',
                    height: '700px',
                    border: 'none'
                  }}
                />
              )}
            </TemplateImageWrapper>
            <DialogActions sx={{ padding: 0, marginTop: '35px' }}>
              <Button onClick={handleClose} color="primary" variant="contained" disableElevation>
                Close
              </Button>
            </DialogActions>
          </DialogContent>
        </DialogContentWrapper>
      </Dialog>
    </>
  );
};
